module.exports = __webpack_public_path__ + "static/wtm18-2-0fa53cc5bdde568c0bf34bc8ed14d582.jpeg";